import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import AppContext from './data/AppContext';

const theme = createTheme({
  palette: {
    primary: {
      main: "#127865",
    },
    secondary: {
      main: "#FE7903",
    },
    info:{
      main: "#283D3B",
    }
  },
  
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontWeightRegular: 300,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    // Adding variants with specific colors
    h6: {
      // Default color settings
      color: "#000000",
      '&.light': {
        color: "#EDDDD4"
      },
      '&.dark': {
        color: "#283D3B"
      }
    },
    body1: {
      color: "#000000",
      '&.light': {
        color: "#EDDDD4"
      },
      '&.dark': {
        color: "#283D3B"
      }
    },
    body2: {
      color: "#000000",
      '&.light': {
        color: "#EDDDD4"
      },
      '&.dark': {
        color: "#283D3B"
      }
    },
    subtitle1: {
      color: "#000000",
      '&.light': {
        color: "#EDDDD4"
      },
      '&.dark': {
        color: "#283D3B"
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <AppContext>
      <App />
    </AppContext>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
